import React from "react";
import { ValidForm } from "./Home";

function App() {
  return <ValidForm data={'data'} />;
}

export default App;
